import apiClient from './api'
class InsuranceService {
  async CreateInsuranceCompany(postData: any) {
    try {
      const response = await apiClient.post('/InsuranceCompany', postData)
      return response.data
    } catch (err) {
    }
  }

  async GetAllInsuranceCompanies() {
    try {
      const response = await apiClient.get(`/InsuranceCompany/all`)
      return  response.data;
    } catch (err) {
      return { success: false }
    }
  }

  async GetInsuranceOnState(id: any) {
    try {
      const response = await apiClient.get(`State/${id}/insurance-companies`);
      return response.data;

    } catch (err) {
    }
  }

  async GetDentistInsuranceRequest() {
    try {
      const response = await apiClient.get("/Credential/dashboard");
      return response.data;

    } catch (err) {
    }
  }

  async GetDentistInsuranceByState(id: any) {
    try {
      const response = await apiClient.get(`/State/${id}/insurance-companies`);
      return response.data;

    } catch (err) {
    }
  }

  async PostInsuranceRequestState(postData: any) {
    try {
      const response = await apiClient.post('/Credential/State', postData)
      return response.data
    } catch (err) {
    }
  }
  async PostInsuranceRequestInsurance(postData: any) {
    try {
      const response = await apiClient.post('/Credential/Insurance-Companies', postData)
      return response.data
    } catch (err) {
      // Rethrown so the caller can show the API's message, e.g. the 400 for a paid credential request
      throw err
    }
  }
  async GetAdminInsuranceRequest() {
    try {
      const response = await apiClient.get("/Admin/dashboard");
      return response.data;

    } catch (err) {
    }
  }

  async DeleteInsuranceCompeny(InsuranceCompanyId: any) {
    try {
      const response = await apiClient.delete(`/InsuranceCompany/${InsuranceCompanyId}`);
      return response.data;

    } catch (err) {
    }
  }

  async PutInsuranceCompany(InsuranceCompanyId: any, postData: any) {
    try {
      const response = await apiClient.put(`InsuranceCompany/${InsuranceCompanyId}`, postData)
      return response.data
    } catch (err) {
    }
  }

  async GetSelectedInsurance() {
    try {
      const response = await apiClient.get(`Credential/Insurance-Companies`);
      return response.data;

    } catch (err) {
    }
  }
}

export default new InsuranceService()